import { wx_login,login } from '@/api'
import { rsa } from '@/utils/encryptutil'

export default {
  state: {
    accessToken :''
  },
  mutations: {
  },
  actions: {
    login({ state, dispatch }, params) {
      return wx_login(params).then((res) => {
        state.accessToken = res.accessToken
      })
    },
    async LoginSuccess({ commit, dispatch }, res) {
      console.log('LoginSuccess',res)
      const token = res.tokenHead + ' ' +res.token
      return dispatch('setToken',res.tokenHead + ' ' +res.token)
    },
    async LoginByUsername({ dispatch }, params={}) {
      params.username = rsa.encrypt(params.username.trim())
      params.password = rsa.encrypt(params.password.trim())
      //手机号码与web端保持一致，走RSA加密；短信验证码明文提交
      if (params.phone) params.phone = rsa.encrypt(params.phone.trim())
      const res  = await login(params)
      return dispatch("LoginSuccess",res)
    },
  }
}
